<template>
  <input v-model="textValue" color="fourth" :placeholder="placeholder"
    @change="onChangeHandler" class="search-bar bs primary right-space" />
</template>

<script>
export default {
  props: {
    value: String,
    placeholder: String
  },
  data() {
    return {
      textValue: ''
    }
  },
  mounted() {
    this.textValue = this.value
  },
  methods: {
    onChangeHandler() {
      this.$emit('change', this.textValue)
    }
  }
}
</script>

<style>
.search-bar {
  border: 1px solid black;
}
</style>
